import {Messages} from '../../constants';

const validation = {
  email: {
    presence: {
      message: Messages.RequiredEmailValidationMessage,
      allowEmpty: false,
    },
    email: {
      message: Messages.InvalidEmailValidationMessage,
    },
  },
  celular: {
    presence: {
      message: Messages.RequiredCelularValidationMessage,
      allowEmpty: false,
    },
  },
};

export default validation;
